import React, { useState } from 'react';
import { Video, Image, Award } from 'lucide-react';
import VideosManager from './VideosManager';
import GalleryManager from './GalleryManager';
import ExcellenceManager from './ExcellenceManager';

const MediaManager = () => {
  const [activeTab, setActiveTab] = useState('videos'); // videos, gallery, or excellence

  return (
    <div className="min-h-screen bg-gray-900">
      {/* Main Heading */}
      <div className="mb-6">
        <h1 className="text-3xl font-black text-white">MEDIA</h1>
        <p className="text-gray-400 mt-1">Manage videos, gallery images, and excellence certificates</p>
      </div>

      {/* Tab Navigation */}
      <div className="bg-gray-800 border-b border-gray-700 mb-6">
        <div className="flex space-x-1">
          <button
            onClick={() => setActiveTab('videos')}
            className={`flex items-center space-x-2 px-6 py-4 font-medium transition-colors border-b-2 ${
              activeTab === 'videos'
                ? 'text-yellow-400 border-yellow-400 bg-gray-900/50'
                : 'text-gray-400 border-transparent hover:text-white hover:bg-gray-700/50'
            }`}
          >
            <Video size={20} />
            <span>Videos</span>
          </button>
          <button
            onClick={() => setActiveTab('gallery')}
            className={`flex items-center space-x-2 px-6 py-4 font-medium transition-colors border-b-2 ${
              activeTab === 'gallery'
                ? 'text-yellow-400 border-yellow-400 bg-gray-900/50'
                : 'text-gray-400 border-transparent hover:text-white hover:bg-gray-700/50'
            }`}
          >
            <Image size={20} />
            <span>Gallery</span>
          </button>
          <button
            onClick={() => setActiveTab('excellence')}
            className={`flex items-center space-x-2 px-6 py-4 font-medium transition-colors border-b-2 ${
              activeTab === 'excellence'
                ? 'text-yellow-400 border-yellow-400 bg-gray-900/50'
                : 'text-gray-400 border-transparent hover:text-white hover:bg-gray-700/50'
            }`}
          >
            <Award size={20} />
            <span>Excellence</span>
          </button>
        </div>
      </div>

      {/* Content */}
      <div>
        {activeTab === 'videos' && <VideosManager />}
        {activeTab === 'gallery' && <GalleryManager />}
        {activeTab === 'excellence' && <ExcellenceManager />}
      </div>
    </div>
  );
};

export default MediaManager;
